var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({class:{ hidden: _vm.hidden },attrs:{"placeholder":_vm.label,"id":_vm.id,"name":_vm.id}},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }